import React, { Component } from 'react';
import { connect } from 'react-redux';
import MasterPassword from './masterpassword';

import {
  fetchMe,
  activateGlobalSettingsLock,
  deactivateGlobalSettingsLock,
} from '../../actions';

class GlobalLock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      otp: '',
      masterPassword: '',
    };
    this.enableGlobalLock = this.enableGlobalLock.bind(this);
    this.disableGlobalLock = this.disableGlobalLock.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value });
  }

  enableGlobalLock(event) {
    event.preventDefault();
    const { dispatch } = this.props;
    const { otp, masterPassword } = this.state;
    const data = {
      otp,
      masterPassword,
    };
    dispatch(activateGlobalSettingsLock(data)).then((res) => {
      if (res.type === 'ACTIVATE_GLOBAL_SETTINGS_LOCK_SUCCESS') {
        this.props.toggleModal(null);
      }
      dispatch(fetchMe());
    });
  }

  disableGlobalLock(event) {
    event.preventDefault();
    const { dispatch } = this.props;
    const { otp, masterPassword } = this.state;
    const data = {
      otp,
      masterPassword,
    };
    dispatch(deactivateGlobalSettingsLock(data)).then((res) => {
      if (res.type === 'DEACTIVATE_GLOBAL_SETTINGS_LOCK_SUCCESS') {
        this.props.toggleModal(null);
      }
      dispatch(fetchMe());
    });
  }

  render() {
    const { user } = this.props;
    const { masterPassword, otp } = this.state;

    let masterEnabled;
    if (user && user.me && user.me.flags && user.me.flags.masterPasswordSet) {
      masterEnabled = user.me.flags.masterPasswordSet;
    }

    let globalSettingsLock;
    if (user && user.me && user.me.flags && user.me.flags.globalSettingsLock) {
      globalSettingsLock = user.me.flags.globalSettingsLock;
    }

    let otpEnabled;
    if (user.security) {
      const otpHandle = user.security.find(e => e.typeHandle === 'OTP');
      if (otpHandle && otpHandle.statusHandle === 'ACTIVATED') {
        otpEnabled = true;
      }
    }

    const complete = masterPassword && otp;

    if (masterEnabled) {
      if (globalSettingsLock) {
        return (
          <div className="cell small-12 medium-12 large-12">
            <div className="modal-title">
              Global Lock
            </div>
            <div className="grid-x">
              <div className="cell small-12 medium-12 large-12">
                <div className="modal-heading">
                  Disable Global Lock
                </div>
                <div className="modal-subheading">
                  Please enter your master password and 2FA token.
                </div>
              </div>
              <div className="cell small-12 medium-12 large-12">
                <form onSubmit={this.disableGlobalLock} id="form1">
                  <div className="input-wrapper">
                    <input className="modal-input" type="password" id="masterPassword" name="masterPassword" placeholder="Master Password" onChange={this.handleChange} value={masterPassword} autoFocus />
                  </div>
                  <div className="input-wrapper">
                    <input className="modal-input" type="text" id="otp" name="otp" placeholder="2FA Token" onChange={this.handleChange} value={otp} />
                  </div>
                </form>
              </div>
              <div className="cell small-12 medium-12 large-12 modal-actions">
                <button className="button" type="button" onClick={() => this.props.toggleModal(null)}>
                  <span>
                    Cancel
                  </span>
                </button>
                <button className="vlt-button" type="submit" form="form1" disabled={!complete}>
                  <span>
                    Submit
                  </span>
                </button>
              </div>
            </div>
          </div>
        );
      }
      return (
        <div className="cell small-12 medium-12 large-12">
          <div className="modal-title">
            Global Lock
          </div>
          <div className="grid-x">
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">
                Enable Global Lock
              </div>
              <div className="modal-subheading">
                Please enter your master password and 2FA token.
              </div>
            </div>
            <div className="cell small-12 medium-12 large-12">
              <form onSubmit={this.enableGlobalLock} id="form2">
                <div className="input-wrapper">
                  <input className="modal-input" type="password" id="masterPassword" name="masterPassword" placeholder="Master Password" onChange={this.handleChange} value={masterPassword} autoFocus />
                </div>
                <div className="input-wrapper">
                  <input className="modal-input" type="text" id="otp" name="otp" placeholder="2FA Token" onChange={this.handleChange} value={otp} />
                </div>
              </form>
            </div>
            <div className="cell small-12 medium-12 large-12 modal-actions">
              <button className="button" type="button" onClick={() => this.props.toggleModal(null)}>
                <span>
                  Cancel
                </span>
              </button>
              <button className="vlt-button" type="submit" form="form2" disabled={!complete}>
                <span>
                  Submit
                </span>
              </button>
            </div>
          </div>
        </div>
      );
    }

    return <MasterPassword />;
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(GlobalLock);
